import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import ListaAppsItem from './ListaAppsItem';
import TOOLS from '../../componentes/TOOLS';

import '../css/ListaApps.css';

//assets
import ActionNewApp from '../../assets/novo-app.jpg';

class ListaApps extends Component {
    constructor() {
        super();

        this.state = {
            serverResponse: false,
            apps: []
        };
    }

    checkToken(){
        return new Promise(
          (resolve, reject) => { 
            let token= window.localStorage.getItem("AUTH-X-TOKEN");
            resolve(token);
          }
        );
    }    
    
    getApps() {
        fetch(`${TOOLS.serverURL}/`)
            .then(response => response.json())
            .then(json => {
                if (json.ok) {
                    let apps = json.apps;
                    this.setState({ apps, serverResponse: true });
                } else {
                    alert(json.message);
                }

            });
    }

    removeAppOnState(appId){
        let newState= this.state.apps.filter(app => (app.id !== appId));
        this.setState({apps : newState});
    }

    removeAppOnServer(appId) {
        const form = new FormData()
        form.append('id', appId);

        this.checkToken().then(token => {
            if (token) {
                form.append('AUTH-X-TOKEN', token);

                fetch(`${TOOLS.serverURL}/removeapp/`, {
                    method: "POST",
                    body: form
                }).then(response => response.json())
                    .then(json => {
                        if (json.ok) {
                            this.removeAppOnState(appId);

                            window.alert("Excluido com sucesso!");
                        } else {
                            window.alert(json.message);
                        }
                    });

            } else {
                window.alert("Falha ao recuperar o token");
                return false;
            };
        });
    }

    handleRemoveApp(appId) {
        this.removeAppOnServer(appId);
    }

    componentWillMount() {
        this.getApps();
    }

    render() {
        if (this.state.serverResponse) {
            return (
                <div id="listaApps">
                    <div className="listaAppItens">
                        <div className="listaAppItens-icone">
                            <img src={ActionNewApp} alt="New App" />
                        </div>
                        <div className="listaAppItens-actions">
                        <Link to="/adm/app"><i className="fas fa-edit"></i></Link>
                        </div>
                    </div>
                    {this.state.apps.map(app => <ListaAppsItem app={app} key={app.id} callBackRemoveApp={this.handleRemoveApp.bind(this)} />)}
                </div>
            );
        } else {
            return (
                <div id="listaApps">
                    Carregando...
            </div>
            );
        }
    }
}

export default ListaApps;



// WEBPACK FOOTER //
// ./src/adm/componentes/ListaApps.js